export const storage = {
  hash: '@minicov/hash',
  showPushCount: '@minicov/showPushCount',
  showPushInfoAlert: '@minicov/showPushInfoAlert',
  enabledInitCount: '@minicov/enabledInitCount',
};
